import { createContext, useContext, useState, useCallback } from "react";

const EditModeContext = createContext(null);

export const EditModeProvider = ({ children }) => {
	const [activeField, setActiveField] = useState(null);
	const cancelAll = useCallback(() => setActiveField(null), []);

	return (
		<EditModeContext.Provider value={{ activeField, setActiveField, cancelAll }}>
			{children}
		</EditModeContext.Provider>
	);
};

export const useEditMode = () => useContext(EditModeContext);
